// extracted by mini-css-extract-plugin
export default {"wrapper":"_d5a53ca9","label":"_4a0ec13c","icon":"_a3f4e6b1","text":"_bccfdf27"};